import * as ApiHelpers from './api_helper';
const apiOrigin = `${process.env.REACT_APP_BILLING_API_URL}`

export const BillingRepository = {
  UpdateSubscription: (data) => ApiHelpers.api_call('POST', 'subscription/update', data, apiOrigin)
};
